import { CultureInfo } from '../culture-info.model';
import { CultureInfoRo } from './ro';

/**
 * @ignore
 */
export const CultureInfoRoRO: CultureInfo = {
  name: 'ro-RO',
  displayName: 'Romanian (Romania)',
  iso3LanguageCode: 'ron',
  iso2LanguageCode: 'ro',
  ietfLanguageTag: 'ro-RO',
  parent: CultureInfoRo
};
